import { Grid } from "@mui/material";
import { Card } from "pepsico-ds";
import PropTypes from "prop-types";
import { useContext } from "react";
import { GlobalConfigContext } from "../../context/GlobalConfigContext";
import { formatDateTz } from "../../utils/commons";
import ButtonGroupDynamic from "../common/ButtonGroupDynamic";
import "./customizedRewards.scss";
import { useRewardsActions } from "./rewardsActions";

const CustomizedRewardsGrid = ({
  customizedRewardsData,
  handleViewReward,
  handleEditReward,
  handleDeleteReward,
}) => {
  const {
    handleViewReward: defaultHandleViewReward,
    handleEditReward: defaultHandleEditReward,
    handleDeleteReward: defaultHandleDeleteReward,
  } = useRewardsActions();

  // Use props if provided, otherwise use defaults from hook
  const onViewReward = handleViewReward || defaultHandleViewReward;
  const onEditReward = handleEditReward || defaultHandleEditReward;
  const onDeleteReward = handleDeleteReward || defaultHandleDeleteReward;
  const { programTimezone } = useContext(GlobalConfigContext);

  if ((customizedRewardsData || []).length === 0) {
    return <div className="no-data-message">No rewards found</div>;
  }

  return (
    <div>
      <Grid container spacing={2}>
        {customizedRewardsData.map((item) => (
          <Grid key={item.id} item xs={12} sm={6} md={4} lg={3}>
            <Card
              key={item.id}
              icon=""
              ellipsis=""
              style={{
                padding: "0px",
                borderRadius: "10px",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                cursor: "default",
              }}
              onClick={() => onViewReward(item)}
            >
              <div className="reward-card-container">
                <div className="reward-details">
                  {/* Status and Type Labels */}
                  <div className="reward-status-type">
                    <span
                      className={`reward-status-badge ${(item?.isActive === false ? "inactive" : "active").toLowerCase()}`}
                    >
                      {item?.isActive === false ? "Inactive" : "Active"}
                    </span>
                  </div>

                  {/* Reward Name */}
                  <h3 className="reward-name">{item?.name || "-"}</h3>

                  {/* Fields in 3 columns */}
                  <div className="fields-row">
                    <div className="field-column">
                      <span className="field-label">Quantity</span>
                      <span className="field-value">{item?.newQuantity || "-"}</span>
                    </div>

                    <div className="field-column">
                      <span className="field-label">Campaigns Linked</span>
                      <span className="field-value">
                        {item?.uniqueCampaignCount || 0}
                      </span>
                    </div>

                    <div className="field-column">
                      <span className="field-label">Rewards</span>
                      <span className="field-value">
                        {item?.uniqueRewardCount || 0}
                      </span>
                    </div>
                  </div>

                  <div className="fields-row">
                    <div className="field-column">
                      <span className="field-label">Start Date</span>
                      <span className="field-value">
                        {formatDateTz(
                          item?.startDate,
                          programTimezone,
                          "DD/MM/YYYY"
                        ) || "-"}
                      </span>
                    </div>

                    <div className="field-column">
                      <span className="field-label">End Date</span>
                      <span className="field-value">
                        {formatDateTz(
                          item?.endDate,
                          programTimezone,
                          "DD/MM/YYYY"
                        ) || "-"}
                      </span>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="button-group-container">
                    <ButtonGroupDynamic
                      items={[
                        {
                          icon: "visibility",
                          onClick: () => onViewReward(item),
                          tooltip: "View",
                        },
                        {
                          icon: "edit",
                          onClick: () => onEditReward(item),
                          tooltip: "Edit",
                        },
                        // Only show delete button for inactive rewards
                        ...(!item?.isActive
                          ? [
                              {
                                icon: "delete",
                                onClick: () => onDeleteReward(item),
                                tooltip: "Delete",
                              },
                            ]
                          : []),
                      ]}
                      spacing="1px"
                      size="medium"
                      variant="control"
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

CustomizedRewardsGrid.propTypes = {
  customizedRewardsData: PropTypes.array.isRequired,
  handleViewReward: PropTypes.func,
  handleEditReward: PropTypes.func,
  handleDeleteReward: PropTypes.func,
};

export default CustomizedRewardsGrid;
